const REGISTER_FORM = "#bss-b2b-register-form";
const VISIBLE_CONTROL = "input:not([type=hidden]), select, textarea";

function hasAccessibleName(control) {
  if (control.getAttribute("aria-label")?.trim()) return true;
  if (control.getAttribute("aria-labelledby")?.trim()) return true;
  if (control.id && document.querySelector(`label[for="${CSS.escape(control.id)}"]`)) return true;
  return Boolean(control.closest("label"));
}

function fieldLabel(field) {
  return field.querySelector(".label-field");
}

function labelText(label) {
  return label.textContent.replace(/\*/g, "").replace(/\s+/g, " ").trim();
}

function repairField(field) {
  const control = field.querySelector(VISIBLE_CONTROL);
  if (!control || hasAccessibleName(control)) return;

  const label = fieldLabel(field);
  if (!label) return;

  if (control.id) {
    if (label.getAttribute("for") !== control.id) label.setAttribute("for", control.id);
    return;
  }

  const name = labelText(label);
  if (name && control.getAttribute("aria-label") !== name) control.setAttribute("aria-label", name);
}

function repairRegistrationLabels() {
  const form = document.querySelector(REGISTER_FORM);
  if (!form) return;
  form.querySelectorAll(".bss-b2b-rf-field").forEach(repairField);
}

function watchRegistrationForm() {
  repairRegistrationLabels();

  const observer = new MutationObserver(repairRegistrationLabels);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["for"],
  });

  document.addEventListener("BSS_condition_field_change", repairRegistrationLabels);
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchRegistrationForm);
  } else {
    watchRegistrationForm();
  }
}
